import { fetchGet } from '../helperApi'

export const fetchGrants = () => {
    return fetchGet('user/grants')
}
